import { render, staticRenderFns } from "./AssignmentDetails.vue?vue&type=template&id=d139ef2a&scoped=true&"
import script from "./AssignmentDetails.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetails.vue?vue&type=style&index=0&id=d139ef2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d139ef2a",
  null
  
)

export default component.exports